module.exports = __webpack_public_path__ + "components/flag/static/square/st-dafba84c6c06b87a0132aa419eb44057.svg";